import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RecruitmentDataService {
  recruitmentsData: any;
  constructor() { }

  get statuses(): { status: string, colorClass: string }[] {
    return [
      { status: 'Draft', colorClass: 'primary' },
      { status: 'Open', colorClass: 'success' },
      { status: 'Closed', colorClass: 'danger' },
      { status: 'Paused', colorClass: 'warning' },
      { status: 'Cancelled', colorClass: 'danger' },
      { status: 'Under Review', colorClass: 'primary' },
      { status: 'Interviewing', colorClass: 'info' },
      { status: 'Offered', colorClass: 'success' },
      { status: 'Offer Extended', colorClass: 'success' },
      { status: 'Hired', colorClass: 'success' },
      { status: 'Rejected', colorClass: 'danger' },
      { status: 'On Hold', colorClass: 'warning' }
    ];
  }

  getColorByStatus(status: string): string {
    const foundStatus = this.statuses.find(s => s.status === status);
    return foundStatus ? foundStatus.colorClass : 'text-muted'; // Default color class if status not found
  }

  set recruitments(data) {
    this.recruitmentsData = data;
  }

  getRecruitmentCounts(): { status: string, count: number, colorClass: string }[] {
    // Create an initial object with all statuses set to zero
    const initialCounts = this.statuses.reduce((acc, status) => {
      acc[status.status] = 0;
      return acc;
    }, {});

    // Count the occurrences of each status
    this.recruitmentsData?.forEach(recruitment => {
      if (initialCounts.hasOwnProperty(recruitment.status)) {
        initialCounts[recruitment.status]++;
      }
    });

    // Convert the counts to an array of objects with status and count
    return this.statuses.map(status => ({
      status: status.status,
      count: initialCounts[status.status],
      colorClass: status.colorClass
    }));
  }
}
